/** If products have to be paid. */
export enum PaymentMode { 
	/**
	* Products must be paid regularly.
	*             This is the case for a normal vending machine.
	*/
	Pay = "Pay", 
	Free = "Free"
}
